import styled from "styled-components"

import { colors, spacing, oldBreakpoints as breakpoints } from "@izettle/otto"

import { Header } from "@/core/components/shared"

export const ModalHeader = styled(Header)`
  border-radius: ${spacing.xSmall} ${spacing.xSmall} 0 0;
`

export const Background = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #00000050;
  transition: opacity 100ms ease, z-index 100ms ease;
  z-index: 2000;
  opacity: 1;

  &.hidden {
    z-index: -1;
    opacity: 0;
    visibility: hidden;
  }
`

export const ModalContainer = styled.div<{ full?: boolean }>`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2001;
  width: 100vw;
  left: 0;
  right: 0;
  visibility: hidden;

  transition: bottom 360ms ease, top 360ms ease;

  ${({ full }) => `
    top: ${full ? "100vh" : "auto"};
    bottom: ${full ? "-100vh" : "-232px"};
    height: ${full ? "100vh" : "232px"};
    .show {
      top: 0px;
    }
  `};

  &.show {
    visibility: initial;
    bottom: 0px;
    ${({ full }) => (full ? "top: 0px;" : "")}
  }
`

export const ModalWrapper = styled.div`
  position: relative;
  background-color: ${colors.background.default};
  display: flex;

  overflow: auto;
  height: 100%;
  width: 100%;

  max-width: ${breakpoints.medium};

  &.small {
    border-radius: ${spacing.xSmall} ${spacing.xSmall} 0 0;
  }

  @media (min-width: ${breakpoints.medium}) {
    max-height: calc(100% - 48px);
    min-height: 232px;
  }
`
export const ModalContent = styled.div`
  padding-top: 80px;
  height: calc(100% - 80px);
  width: 100%;
`
